// extracted by mini-css-extract-plugin
module.exports = {"form":"SignIn_form__2i2qD"};